'use strict';

const util = {
    appendParamToURL: require('./appendParamToURL'),
    updateQueryStringParameter: require('./updateQueryStringParameter'),
    removeParamFromURL: require('./removeParamFromURL'),
    appendParamsToUrl: require('./appendParamToURL'),
    getQueryString: require('./getQueryString'),
    getQueryParameter: require('./getQueryParameter'),
    elementInViewport: require('./elementInViewport'),
    ajaxUrl: require('./ajaxUrl'),
    toAbsoluteUrl: require('./toAbsoluteUrl'),
    loadCssFile: require('./dynamicCss').loadCssFile,
    loadDynamicCss: require('./dynamicCss').loadDynamicCss,
    clearDynamicCss: require('./dynamicCss').clearDynamicCss,
    getQueryStringParams: require('./getQueryStringParams'),
    getLocationHash: require('./getLocationHash'),
    setLocationHash: require('./setLocationHash'),
    getTriggerFromHash: require('./getTriggerFromHash'),
    fillAddressFields: require('./fillAddressFields'),
    limitCharacters: require('./limitCharacters'),
    setDeleteConfirmation: require('./setDeleteConfirmation'),
    scrollBrowser: require('./scrollBrowser'),
    isMobile: require('./isMobile'),
    isMobileWidth: require('./isMobileWidth'),
    isMobileOrTabletWidth: require('./isMobileOrTabletWidth'),
    sortSelectOptions: require('./sortSelectOptions'),
    getCookie: require('./getCookie'),
    createCookie : require('./createCookie'),
    getCountryFromLocaleCookie: require('./getCountryFromLocaleCookie'),
    getScreenBreakpointSize: require('./getScreenBreakpointSize'),
    fixBackgroundImagesFlickerIE: require('./fixBackgroundImagesFlickerIE'),
    isParentalConsentNeeded: require('./isParentalConsentNeeded'),
    generateUniqueGuid: require('./generateUniqueGuid'),
    removeDuplicatesFromArray: require('./removeDuplicatesFromArray'),
    transformValueAsArray: require('./transformValueAsArray'),
    replaceCurrencyFormattedValue: require('./replaceCurrencyFormattedValue'),
    getUpdatedURLWithParams: require('./getUpdatedURLWithParams'),
    latinise: require('./latinise')
};

/**
 * Create a shared util object that we can access from component JS files
 */
window.util = {
    isMobile: util.isMobile,
    transformValueAsArray: util.transformValueAsArray
};

module.exports = util;
